export default __webpack_public_path__ + "static/media/hand.9cd7eef7.svg";